import React from "react";
import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";

interface IOSSwitchComponentProps {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  value?: string;
}

/**
 * Estilo "iOS" para o Switch do Material UI
 */
const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

/**
 * Componente de Switch com estilo iOS
 */
const IOSSwitchComponent: React.FC<IOSSwitchComponentProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  value,
}) => {
  return (
    <FormGroup>
      <FormControlLabel
        sx={{
          // Dentro de FormControlLabel, podemos selecionar a classe que estiliza o texto
          "& .MuiFormControlLabel-label": {
            marginLeft: "8px", // Ajuste de espaçamento
          },
          marginLeft: "0px",
        }}
        control={
          <IOSSwitch
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            value={value}
          />
        }
        label={label}
      />
    </FormGroup>
  );
};

export default IOSSwitchComponent;
